class FaqAccordion extends HTMLElement {
  constructor() {
    super();
    this.tabs = null;
    this.groups = null;
    this.boundTabClick = null;
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.faq-accordion__tab');
    this.groups = this.querySelectorAll('.faq-accordion__group');

    if (this.tabs.length === 0) return;

    this.boundTabClick = (event) => this.onTabClick(event.currentTarget);
    this.tabs.forEach((tab) => tab.addEventListener('click', this.boundTabClick));
  }

  disconnectedCallback() {
    if (!this.boundTabClick || !this.tabs) return;
    this.tabs.forEach((tab) => tab.removeEventListener('click', this.boundTabClick));
    this.boundTabClick = null;
  }

  onTabClick(selectedTab) {
    const filter = selectedTab.getAttribute('data-filter');

    this.tabs.forEach((tab) => {
      const isActive = tab === selectedTab;
      tab.classList.toggle('faq-accordion__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.groups.forEach((group) => {
      if (filter === 'all') {
        group.classList.remove('faq-accordion__group--hidden');
        return;
      }
      const groupFilter = group.getAttribute('data-filter');
      const visible = groupFilter === filter;
      group.classList.toggle('faq-accordion__group--hidden', !visible);
    });
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion);
}
